import React from 'react';
import { IActivityLogTabPanel } from './interfaces';
import { TabPanel } from '../../../../../components/tabs';
import { ManagedDataTable } from '../../../../../components/ManagedDataTable';
import { useGetActivityLogs } from '../../../../../reactQuery/Activities/activities';
import { IManagedDataTable } from '../../../../../components/ManagedDataTable/interfaces';
import { ActivityLog } from '../../../../../api/activitiesApi/interfaces';
import { getColumns } from '../../../../ActivitiesLog/Overview/helpers';
import { ROUTES } from '../../../../../routes/Routes';
import { useNavigate } from 'react-router';

export const ActivityLogTabPanel: React.FC<IActivityLogTabPanel> = ({
  value,
  index,
  contactId,
}): JSX.Element => {
  const navigate = useNavigate();
  const onRowClick = (row: ActivityLog): void => {
    navigate(ROUTES.activityLog.details(row.id));
  };

  return (
    <TabPanel value={value} index={index}>
      <ManagedDataTable
        query={useGetActivityLogs as IManagedDataTable<ActivityLog>['query']}
        columns={getColumns(true)}
        onRowClick={onRowClick}
        initialSort={{ field: 'performedAt', sort: 'desc' }}
        filter={[
          {
            field: 'contact',
            operator: '=',
            value: contactId,
          },
        ]}
      />
    </TabPanel>
  );
};
